import React from 'react';
import { useTranslation } from 'react-i18next';
import { View } from 'react-native';

import { SizedBox } from '@/components/SizedBox';
import { Text } from '@/components/TextComponent';
import { ClosedLoopInfoProps, ClosedLoopMethodProps } from '@/feature/withdraw/components/closedLoop.types';
import { useHasSocialWallet } from '@/hooks/use-has-social-wallet';
import { common } from '@/styles/styles';
import { toTitleCase } from '@/utils/toTitleCase';

import { ClosedLoopItem } from './ClosedLoopItem';

export const ClosedLoopInfo = ({ selectedMethod, amountToWithdraw, distribution }: ClosedLoopInfoProps) => {
    const { t } = useTranslation('wallet');
    const hasSocialWallet = useHasSocialWallet();

    return (
        <View>
            <SizedBox value={5} />
            <Text fontSize={14} fontWeight="normal" lineHeight={20} color={'neutral300'} textAlign={'center'}>
                {hasSocialWallet ? t('closed_loop_redemption_description') : t('closed_loop_withdrawals_description')}
            </Text>
            <SizedBox value={20} />
            {distribution
                ?.slice()
                .sort(a => (a.payment_type_id === selectedMethod.payment_type_id ? -1 : 1))
                .map((method: ClosedLoopMethodProps, idx: number) => (
                    <ClosedLoopItem
                        key={`${method.name}_${idx}`}
                        method={method}
                        title={
                            (idx === 0 ? 'Chosen method' : 'Required distribution') +
                            (method.via_vertical_name ? ` (via ${toTitleCase(method.via_vertical_name)})` : '')
                        }
                    />
                ))}
            <SizedBox value={16} />
            <View style={[common.row, common.justifySpaceBetween]}>
                <Text fontSize={15}>{hasSocialWallet ? t('total_redemption') : t('total_withdrawal')}</Text>
                <Text variant={'titleMedium'} testID="closedLoopTotalWithdrawAmount">
                    ${amountToWithdraw}
                </Text>
            </View>
            <SizedBox value={40} />
        </View>
    );
};
